import { render, staticRenderFns } from "./TransferKey.vue?vue&type=template&id=609562e0&scoped=true&"
import script from "./TransferKey.vue?vue&type=script&lang=ts&"
export * from "./TransferKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609562e0",
  null
  
)

export default component.exports